import * as Actions from '../../../Modules/CmsActions'
import type { Site } from '../../../Types/Models'

interface State {
  loading: boolean
  updating: boolean
  edit?: Site | null
  success: boolean
}

const initialState: State = {
  loading: true,
  updating: false,
  edit: null,
  success: false,
}

const UISiteReducer = (state: State = initialState, action) => {
  switch (action.type) {
    case Actions.REQUEST_FETCH_SITE:
      return loading(state)

    case Actions.FINISH_FETCH_SITE:
      return updateEditInfoWithLoaded(state, action.payload.site)

    case Actions.REQUEST_UPDATE_SITE:
      return updating(state)

    case Actions.FINISH_UPDATE_SITE:
      return successEdit(state, action.payload.values)

    case Actions.FINISH_UPDATE_SITE_PROPERTY:
      return successEditProperty(state)

    case Actions.RESET_UPDATE_SITE_STATUS:
      return resetSuccess(state)

    case Actions.LOGOUT:
      return initialState

    default:
      return state
  }
}

function loading(state) {
  return { ...state, loading: true }
}

function loaded(state) {
  return { ...state, loading: false }
}

function updateEditInfoWithLoaded(state, site) {
  const updated = { ...state, edit: site }
  return loaded(updated)
}

function updating(state) {
  return { ...state, updating: true }
}

function successEdit(state, values) {
  const succeed = {
    ...state,
    edit: { ...state.edit, ...values },
    updating: false,
    success: true,
  }
  return loaded(succeed)
}

function successEditProperty(state) {
  const succeed = { ...state, success: true, updating: false }
  return loaded(succeed)
}

function resetSuccess(state) {
  return { ...state, success: false }
}

export default UISiteReducer
